import {NotificationService} from "../services/NotificationService";
import {QueuedCommand} from "../entities/QueuedCommand";
import {QueuedCommandService} from "../services/QueuedCommandService";

export class CommandManager {
    static $inject = ['QueuedCommandService','NotificationService'];
    constructor(public queuedCommandService:QueuedCommandService, public notificationService:NotificationService){
    }
    runCommands(qqs:QueuedCommand[]){
        this.queuedCommandService.inserts(qqs).then((data)=>{
            this.notificationService.notify("QueuedCommands scheduled successfully.");
        })
        .catch((exc)=>{
            this.notificationService.notifyError("Got error:"+exc, exc);
        });
    }
}
